import { exeRequest } from '../utils/APIUtils';

export default {
  // Récupérer toutes les villes
  getAll: async () => exeRequest('/admin/cities', 'GET'),

  // Récupérer une ville par son ID
  getById: async (id) => exeRequest(`/admin/cities/${id}`, 'GET'),

  // Créer une nouvelle ville
  create: async (data) => exeRequest('/admin/cities', 'POST', data),

  // Mettre à jour une ville
  update: async (id, data) => exeRequest(`/admin/cities/${id}`, 'PUT', data),

  // Supprimer une ville
  delete: async (id) => exeRequest(`/admin/cities/${id}`, 'DELETE'),

  // Activer/Désactiver une ville
  toggle: async (id) => exeRequest(`/admin/cities/${id}/toggle`, 'PATCH'),

  // Définir comme ville par défaut
  setDefault: async (id) => exeRequest(`/admin/cities/${id}/set-default`, 'PATCH'),

  // Seed des villes par défaut
  seed: async () => exeRequest('/admin/cities/seed', 'POST'),
};
